import { useState } from 'react';
import InfoIcon from '@mui/icons-material/Info';
import { useTranslation } from 'react-i18next';
import CustomButton from '../../../../../../components/button/CustomButton';
import { secondaryBlue } from '../../../../../../utils/color';
import AboutFinancingModal from './components/AboutFinancingModal';

import useMode from '../../../../../../utils/hooks/useMode';
import { EnumMode } from '../../../../../../utils/context/Mode.context';

const AboutFinancing = () => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const { mode } = useMode();

  const handleOpen = () => {
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  let buttonText = t('financing.aboutPayment');
  if (mode === EnumMode.Client) {
    buttonText = t('financing.aboutDeferredPayment');
  }

  return (
    <>
      <CustomButton
        startIcon={<InfoIcon fill={secondaryBlue[500]} />}
        variant="primaryLight"
        onClick={handleOpen}
      >
        {buttonText}
      </CustomButton>

      <AboutFinancingModal isOpen={isOpen} onClose={handleClose} />
    </>
  );
};

export default AboutFinancing;
